import { useEffect, useState } from "react";
import { Flex } from "../../../../styled-system/jsx";
import { css } from "../../../../styled-system/css";
import { Select } from "../../../components/fields/base/Select";
import { Button } from "../../../components/core/basic/Button";
import { FaCheck } from "react-icons/fa6";
import { UserRolesTooltip } from "./OrgUsersTable";
import { useModifyRoleMutation } from "../api/useUpdateRoleMutation";
import { type OrgUser } from "../../../zodios/apiDefinitions/api/userManagement";

type Props = {
  row: { original: OrgUser };
  roleOptions: { label: string; value: number }[];
  isSelectDisabled?: boolean;
  isConfirmButtonDisabled?: boolean;
};

const RoleCell = ({ row, roleOptions, isSelectDisabled = false, isConfirmButtonDisabled = false }: Props) => {
  const initRole = row.original.roles[0];

  const [role, setRole] = useState(initRole?.role_id);
  const { mutate: mutateRole } = useModifyRoleMutation();
  const { id: userId } = row.original;

  useEffect(() => {
    setRole(initRole?.role_id);
  }, [initRole]);

  if (!initRole) {
    return null;
  }

  return (
    <Flex className={css({ gap: "medium", alignItems: "center", paddingY: "xsmall", paddingX: "medium" })}>
      <Select
        onSelectionChange={(value) => {
          if (typeof value !== "number") {
            return;
          }
          setRole(value);
        }}
        selectedKey={role}
        items={roleOptions}
        css={{ width: "150px" }}
        isDisabled={isSelectDisabled}
      />
      <UserRolesTooltip />
      <Button
        onPress={() => {
          if (!role) {
            return;
          }
          mutateRole({ user_id: userId, rbac_role_id: role, status: "active" });
        }}
        size={"small"}
        isDisabled={isConfirmButtonDisabled || role === initRole.role_id}
      >
        <FaCheck />
      </Button>
    </Flex>
  );
};

export default RoleCell;
